import React from 'react';
import LocationTemplate from './LocationTemplate';

const FremontPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Fremont"
      stateName="North Carolina"
      countyName="Wayne"
      zipCodes={["27830"]}
      latitude={35.5446}
      longitude={-78.0206}
      population={1255}
      historicalFact="Originally called Nahunta, renamed in 1869 after Civil War General John C. Fremont."
      nearbyTowns={[
        "Goldsboro, NC",
        "Mount Olive, NC",
        "Pikeville, NC",
        "Seven Springs, NC",
        "Eureka, NC",
        "Wilson, NC",
        "Snow Hill, NC",
        "Kinston, NC"
      ]}
    />
  );
};

export default FremontPage;